import axios from 'axios';
import { clearAuthSession, getAuthToken } from './authStorage';

const resolveRuntimeBaseUrl = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (window.__ENV?.API_URL) {
    return window.__ENV.API_URL;
  }

  const { protocol, hostname, port } = window.location;

  // file:// cannot make API calls - use production API
  if (protocol === 'file:') {
    return 'https://maintenance.vajraglobal.com';
  }

  const isLocalhost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.endsWith('.local');

  // On localhost, use local backend for dev, otherwise production
  if (isLocalhost) {
    return process.env.REACT_APP_API_URL || 'https://maintenance.vajraglobal.com';
  }

  return port ? `${protocol}//${hostname}:${port}` : `${protocol}//${hostname}`;
};

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  resolveRuntimeBaseUrl() ||
  'https://maintenance.vajraglobal.com';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    // Don't auto-redirect on 401 for auth endpoints like login,
    // so the UI can show proper error messages.
    const requestUrl = error.config?.url || '';
    const isAuthEndpoint =
      requestUrl.includes('/api/auth/login') ||
      requestUrl.includes('/api/auth/register') ||
      requestUrl.includes('/api/auth/forgot-password');

    if (status === 401 && !isAuthEndpoint) {
      clearAuthSession();
      // Avoid redirect loop: only redirect if not already on login/register
      if (typeof window !== 'undefined') {
        const path = window.location.pathname || '';
        if (!path.startsWith('/login') && !path.startsWith('/register') && !path.startsWith('/invite')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  },
);

export { api, API_BASE_URL };


